import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { CompositeMenuButton } from '#/modules/commonComponents/button';
import usePrintInventoryStockLabels from '#/modules/imsMgmt/inventoryStock/hooks/usePrintInventoryStockLabels';

/**
 * 庫存標籤複合列印鈕（slate）。預設左＝批次列印；選單含批次／全部。
 * 不吃 lines；可注入 printMutation。
 */
const PrintInventoryStockLabelsButton = ({
  selectedInventoryStockIds = [],
  allInventoryStockIds = [],
  printMutation: printMutationProp = null,
  defaultItemId = 'batch',
}) => {
  const internalPrintMutation = usePrintInventoryStockLabels();
  const printMutation = printMutationProp ?? internalPrintMutation;
  const isPrinting = printMutation.isPending;

  const selectedIds = useMemo(
    () => selectedInventoryStockIds.filter(Boolean),
    [selectedInventoryStockIds],
  );
  const allIds = useMemo(
    () => allInventoryStockIds.filter(Boolean),
    [allInventoryStockIds],
  );

  const items = useMemo(
    () => [
      {
        id: 'batch',
        label: '批次列印',
        disabled: selectedIds.length === 0 || isPrinting,
        onSelect: () => {
          if (selectedIds.length === 0 || isPrinting) {
            return;
          }
          printMutation.mutate(selectedIds);
        },
      },
      {
        id: 'all',
        label: '全部列印',
        disabled: allIds.length === 0 || isPrinting,
        onSelect: () => {
          if (allIds.length === 0 || isPrinting) {
            return;
          }
          printMutation.mutate(allIds);
        },
      },
    ],
    [allIds, isPrinting, printMutation, selectedIds],
  );

  return (
    <CompositeMenuButton
      variant="slate"
      label={isPrinting ? '列印中…' : '列印標籤'}
      defaultItemId={defaultItemId}
      disabled={isPrinting}
      caretAriaLabel="列印標籤選項"
      items={items}
      aria-busy={isPrinting || undefined}
    />
  );
};

PrintInventoryStockLabelsButton.propTypes = {
  selectedInventoryStockIds: PropTypes.arrayOf(PropTypes.string),
  allInventoryStockIds: PropTypes.arrayOf(PropTypes.string),
  printMutation: PropTypes.object,
  defaultItemId: PropTypes.string,
};

export default PrintInventoryStockLabelsButton;
